module.exports = __webpack_public_path__ + "media/entities/6003-8e057674.png";